import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let context_path = process.env.VUE_APP_CONTEXT_PATH;

const router= new Router({
  mode: "history",
  routes: [
    {
      path: "/trainings/calendar",
      name: "trainingCalendar",
      component: () => import("./views/participation/trainingCalendarView"),
      meta: {
        isPublic: true
      },
    },
    {
      path: "/training/add",
      name: "trainingAdd",
      component: () => import("./views/training/trainingAddView")
    },
    {
      path: "/training/:id",
      name: "trainingView",
      component: () => import("./views/training/trainingFolderView")
    },
    {
      path: "/announcement/:id",
      name: "trainingAnnouncement",
      component: () => import("./views/training/trainingsAnnouncementView")
    },
    {
      path: "/trainings",
      name: "trainings",
      component: () => import("./views/training/trainingsView")
    },
    {
      path: "/trainings/apply",
      name: "applications",
      component: () => import("./views/participation/trainingApplicationsView")
    },
    {
      path: "/participations",
      name: "participations",
      component: () => import("./views/participation/trainingParticipationsView")
    },
    {
      path: "/parametrics/modules",
      name: "modules",
      component: () => import("./views/parametrics/modulesView")
    },
    {
      path: "/parametrics/module/add",
      name: "moduleAdd",
      component: () => import("./views/parametrics/moduleAddView")
    },
    {
      path: "/parametrics/module/:id",
      name: "moduleEdit",
      component: () => import("./views/parametrics/moduleEditView")
    },
    {
      path: "/parametrics/sessions",
      name: "sessions",
      component: () => import("./views/parametrics/sessionsView")
    },
    {
      path: "/parametrics/criterias",
      name: "criterias",
      component: () => import("./views/parametrics/criteriasView")
    },
    {
      path: "/parametrics/announcements",
      name: "announcements",
      component: () => import("./views/parametrics/announcementsView")
    },
    {
      path: "/parametrics/announcements/add",
      name: "announcementsAdd",
      component: () => import("./views/parametrics/announcementsAddView")
    },
    {
      path: "/parametrics/announcements/:id",
      name: "announcementsEdit",
      component: () => import("./views/parametrics/announcementsEditView")
    },
    {
      path: "/leaders",
      name: "leaders",
      component: () => import("./views/leaders/leadersView")
    },
    {
      path: "/leader/:id",
      name: "leaderEdit",
      component: () => import("./views/leaders/leaderEditView")
    },
    {
      path: "/leaders/add",
      name: "leaderAdd",
      component: () => import("./views/leaders/leaderAddView")
    },
    {
      path: "/evaluations/member/:id",
      name: "evaluationList",
      component: () => import("./views/evaluations/evaluationsListView")
    },
    {
      path: "/evaluations/activity/:activityId/trainee",
      name: "evaluation",
      component: () => import("./views/evaluations/evaluationView")
    },
    {
      path: "/apply-activities/trainee/:id",
      name: "applyActivities",
      component: () => import("./views/applyActivities/applyActivitiesView")
    },

    {
      path: "/apply-activities/trainer/:id",
      name: "applyActivitiesTrainer",
      component: () => import("./views/applyActivities/applyActivitiesTrainerView")
    },
    {
      path: "/apply-activities/management",
      name: "applyActivitiesManagement",
      component: () => import("./views/applyActivities/applyActivitiesManagementView")
    },
    {
      path: "/member/:id/progress",
      name: "trainingProgress",
      component: () => import("./views/progress/trainingProgressView")
    },
    {
      path: "/participation/:id/approve/magic",
      name: "trainingParticipationApproved",
      component: () => import("./views/participation/trainingParticipationApproved")
    },
    {
      path: "/apply-activities/:id",
      name: "applyActivitySubmit",
      component: () => import("./views/applyActivities/applyActivitySubmitView")
    },
    {
      path: "/profile-batch",
      name: "profileBatch",
      component: () => import("./views/training/profileBatchView")
    },
  ],
  base: context_path
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.isPublic)) {
    next()
  } else {
    if (router.app.$keycloak.authenticated) {
      next()
    } else {
      const loginUrl = router.app.$keycloak.createLoginUrl()
      window.location.replace(loginUrl)
    }
  }
})

export default router
